import axios from '@/plugins/Axios'
import Mapper from './Mapper'

function Requests () {
  async function fetchSupplierInfo(id) {
    try {
      const { data } = await axios.get(`/supplier/${id}`)
      return Mapper.supplier(data.supplier)
    } catch (error) {
      return error.response;
    }
  }

  async function inviteSuppliersToChat(payload) {
    try {
      const { data } = await axios.post('/chat/add-supplier', payload)
      return data
    } catch (error) {
      console.log(error)
    } 
  }

  async function fetchSupplierPreviewInfo(id) {
    try {
      const { data } = await axios.get(`/supplier/${id}/preview`)
      console.log(data)
      return Mapper.supplier(data.supplier)
    } catch (error) {
      console.log(error)
    } 
  }

  return {
    fetchSupplierInfo,
    inviteSuppliersToChat,
    fetchSupplierPreviewInfo
  }
}

export default Requests()
